import React from "react";
import { ArrowRight } from "lucide-react";
import { processSteps } from "../data/mock";

export default function HowWeWork() {
  return (
    <section id="process" className="nst-navy text-white py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-30" />
      <div className="glow-orb w-[500px] h-[500px] top-0 left-1/3" style={{ background: "#2E6BF6" }} />

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="pill-label on-dark">How We Work</span>
          <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05]">
            A Platform for High-End <br />
            <span className="text-[#6B9FFF]">Engineering Execution</span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {processSteps.map((step, idx) => (
            <div
              key={step.number}
              className="relative rounded-3xl p-8 border border-white/10 bg-white/[0.03] backdrop-blur-sm card-lift hover:border-[#2E6BF6]/60 hover:bg-white/[0.06]"
            >
              <div className="flex items-center justify-between mb-8">
                <span className="step-number">{step.number} — {step.name.toUpperCase()}</span>
                <span className="text-white/30">
                  {idx < processSteps.length - 1 && <ArrowRight className="w-5 h-5" />}
                </span>
              </div>
              <h3 className="text-3xl font-extrabold mb-4">{step.name}</h3>
              <p className="text-white/70 leading-relaxed mb-6">{step.description}</p>
              <ul className="space-y-2.5 border-t border-white/10 pt-5">
                {step.items.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-sm text-white/80">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#2E6BF6] mt-2 flex-shrink-0" />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
